// admin-frontend/src/reducers/timeline.js
import { timelineConstants as T } from './../actions/constants';

const initial = { byChat: {} };

export default function timelineReducer(state = initial, action) {
    if (!action.chatId) return state;
    const cur = state.byChat[action.chatId] || { items: [], nextCursor: null, loading: false };

    switch (action.type) {
        case T.FETCH_REQUEST:
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { ...cur, loading: true } } };

        case T.FETCH_SUCCESS: {
            const { items, nextCursor } = action.payload || {};
            const base = action?.meta?.append ? [...cur.items, ...(items || [])] : (items || []);
            const sorted = base.slice().sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { items: sorted, nextCursor: nextCursor || null, loading: false } } };
        }

        case T.FETCH_FAILURE:
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { ...cur, loading: false } } };

        case T.APPEND_REALTIME: {
            const exists = cur.items.some(i => i.type === action.item.type && String(i._id) === String(action.item._id));
            const next = exists ? cur.items : [...cur.items, action.item];
            next.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { ...cur, items: next } } };
        }

        case T.MARK_READ_LOCAL: {
            const { userId } = action;
            const next = cur.items.map(it => {
                if (it.type !== 'message') return it;
                const senderId = it.sender?._id || it.sender;
                if (String(senderId) === String(userId)) return it;
                const rb = (it.readBy || []).map(u => (u?._id || u).toString());
                if (rb.includes(String(userId))) return it;
                return { ...it, readBy: [...(it.readBy || []), userId] };
            });
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { ...cur, items: next } } };
        }

        case T.DELETE_MESSAGE_LOCAL: {
            const next = cur.items.filter(it => !(it.type === 'message' && String(it._id) === String(action.messageId)));
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { ...cur, items: next } } };
        }

        case T.CLEAR:
            return { ...state, byChat: { ...state.byChat, [action.chatId]: { items: [], nextCursor: null, loading: false } } };

        default:
            return state;
    }
}
